import React from 'react';
import * as Styled from './TcContent.styled';

const TcContent = () => {
  return (
    <div>
      <Styled.ContentBody>
        These terms and conditions govern your use of this website, by using
        this website you accept these terms and conditions in full. If you
        disagree with these terms and conditions or any part of these terms and
        conditions, you must not use this website.
      </Styled.ContentBody>
      <Styled.ContentSubHeading>Use of content</Styled.ContentSubHeading>
      <Styled.ContentBody>
        Debitsuccess owns the copyright and all other intellectual property
        rights associated with the content on this website. We cannot warrant
        that use of the site will not be interrupted or unavailable due to any
        factors outside our control. You may view, download or print off content
        from this site for your personal, non-commercial, use and information,
        subject to the following restrictions.
      </Styled.ContentBody>
      <Styled.ContentBody>
        You must not:
        <br />
      </Styled.ContentBody>
      <Styled.ContentUnorderedList>
        <li>
          copy, reproduce, republish or duplicate the content of this website;
        </li>
        <li>
          create an archive or database containing the content, for any business
          purpose or other commercial exploitation, without specific consent;
        </li>
        <li>sell, rent or sub-licence material from this website; or</li>
        <li>
          copy, distribute or display the website or any part of it to third
          parties.
        </li>
      </Styled.ContentUnorderedList>
      <Styled.ContentSubHeading>Acceptable use</Styled.ContentSubHeading>
      <Styled.ContentBody>
        You must not use this website in any way that causes, or may cause,
        damage to the website or impairment of the availability or accessibility
        of the website; or in any way which is unlawful, illegal, fraudulent or
        harmful, or in connection with any unlawful, illegal, fraudulent or
        harmful purpose or activity.
      </Styled.ContentBody>
      <Styled.ContentBody>
        You must not use this website to copy, store, host, transmit, send, use,
        publish or distribute any material which consists of (or is linked to)
        any spyware, computer virus, Trojan horse, worm, keystroke logger,
        rootkit or other malicious computer software.
      </Styled.ContentBody>
      <Styled.ContentBody>
        You must not conduct any systematic or automated data collection
        activities on or in relation to this website without Debitsuccess’
        express written consent.
      </Styled.ContentBody>
      <Styled.ContentSubHeading>Restricted access</Styled.ContentSubHeading>
      <Styled.ContentBody>
        Debitsuccess reserves the right to restrict access to areas of this
        website, or indeed this entire website at Debitsuccess’ discretion.
      </Styled.ContentBody>
      <Styled.ContentBody>
        If Debitsuccess provides you with a user ID and password to enable you
        to access restricted areas of this website or services, you must ensure
        that the user ID and password are kept confidential.
      </Styled.ContentBody>
      <Styled.ContentBody>
        Debitsuccess may disable your user ID and password at Debitsuccess’ sole
        discretion without notice or explanation.
      </Styled.ContentBody>
      <Styled.ContentSubHeading>
        Changes to customers’ details
      </Styled.ContentSubHeading>
      <Styled.ContentBody>
        You confirm that should you make any changes to your customers’ details
        or particulars through accessing a restricted area of this website,
        that:
      </Styled.ContentBody>
      <Styled.ContentOrderedList>
        <li>you have the required authority to make such change(s);</li>
        <li>
          you will, in the event of a dispute arising as a consequence of such
          change(s), provide Debitsuccess with evidence to substantiate your
          authority to make the change(s) within 48 hours of Debitsuccess
          requesting evidence;
        </li>
        <li>
          you are solely responsible to your customers for any losses, costs,
          actions, claims, demands, expenses or other liabilities arising as a
          result of the change(s); and
        </li>
        <li>
          you agree to indemnify Debitsuccess to the fullest extent possible
          under law from any losses, costs, actions, claims, demands, expenses
          or other liabilities arising as a result of the change(s).
        </li>
      </Styled.ContentOrderedList>
      <Styled.ContentSubHeading>User Content</Styled.ContentSubHeading>
      <Styled.ContentBody>
        In these terms and conditions, “your user content” means material
        (including without limitation text, images, audio material, video
        material and audio-visual material) that you submit to this website.
      </Styled.ContentBody>
      <Styled.ContentBody>
        You grant to Debitsuccess a worldwide, irrevocable, non-exclusive,
        royalty-free license to use, reproduce, adapt, publish, translate and
        distribute your user content in any existing or future media. You also
        grant to Debitsuccess the right to sub-license these rights, and the
        right to bring an action for infringement of these rights.
      </Styled.ContentBody>
      <Styled.ContentBody>
        Your user content must not be illegal or unlawful, must not infringe any
        third party’s legal rights, and must not be capable of giving rise to
        legal action whether against you or Debitsuccess or a third party (in
        each case under any applicable law).
      </Styled.ContentBody>
      <Styled.ContentBody>
        You must not submit any user content to the website that is or has ever
        been the subject of any threatened or actual legal proceedings or other
        similar complaint.
      </Styled.ContentBody>
      <Styled.ContentBody>
        Debitsuccess reserves the right to edit or remove any material submitted
        to this website, or stored on Debitsuccess’ servers, or hosted or
        published upon this website.
      </Styled.ContentBody>
      <Styled.ContentBody>
        Notwithstanding Debitsuccess’ rights under these terms and conditions in
        relation to user content, Debitsuccess does not undertake to monitor the
        submission of such content to this website.
      </Styled.ContentBody>
      <Styled.ContentSubHeading>No warranties</Styled.ContentSubHeading>
      <Styled.ContentBody>
        This website is provided “as is” without any representations or
        warranties, express or implied. Debitsuccess makes no representations or
        warranties in relation to this website or the information and materials
        provided on this website.
      </Styled.ContentBody>
      <Styled.ContentBody>
        Without prejudice to the generality of the foregoing paragraph,
        Debitsuccess does not warrant that:
      </Styled.ContentBody>
      <Styled.ContentUnorderedList>
        <li>
          this website will be constantly available, or available at all; or
        </li>
        <li>
          the information on this website is complete, true, accurate or
          non-misleading.
        </li>
      </Styled.ContentUnorderedList>
      <Styled.ContentBody>
        Nothing on this website constitutes, or is meant to constitute, advice
        of any kind.
      </Styled.ContentBody>
      <Styled.ContentSubHeading>
        Limitation of liability
      </Styled.ContentSubHeading>
      <Styled.ContentBody>
        Debitsuccess will not be liable to you (whether under the law of
        contract, the law of torts or otherwise) in relation to the contents of,
        or use of, or otherwise in connection with, this website:
      </Styled.ContentBody>
      <Styled.ContentUnorderedList>
        <li>for any indirect, special or consequential loss; or</li>
        <li>
          for any business losses, loss of revenue, income, profits or
          anticipated savings, loss of contracts or business relationships, loss
          of reputation or goodwill, or loss or corruption of information or
          data.
        </li>
      </Styled.ContentUnorderedList>
      <Styled.ContentBody>
        These limitations of liability apply even if Debitsuccess has been
        expressly advised of the potential loss.
      </Styled.ContentBody>

      <Styled.ContentSubHeading>Exceptions</Styled.ContentSubHeading>
      <Styled.ContentBody>
        Nothing in this website disclaimer will exclude or limit any warranty
        implied by law that it would be unlawful to exclude or limit
        Debitsuccess’ liability in respect of any:
      </Styled.ContentBody>
      <Styled.ContentUnorderedList>
        <li>death or personal injury caused by Debitsuccess’ negligence;</li>
        <li>
          fraud or fraudulent misrepresentation on the part of Debitsuccess; or
        </li>
        <li>
          matter which it would be illegal or unlawful for Debitsuccess to
          exclude or limit or to attempt or purport to exclude or limit, its
          liability.
        </li>
      </Styled.ContentUnorderedList>
      <Styled.ContentSubHeading>Reasonableness</Styled.ContentSubHeading>
      <Styled.ContentBody>
        By using this website, you agree that the exclusions and limitations of
        liability set out in this website disclaimer are reasonable.
      </Styled.ContentBody>
      <Styled.ContentBody>
        If you do not think they are reasonable you must not use this website.
      </Styled.ContentBody>
      <Styled.ContentSubHeading>Other Parties</Styled.ContentSubHeading>
      <Styled.ContentBody>
        You accept that, as a limited liability entity, Debitsuccess has an
        interest in limiting the personal liability of its employees. You agree
        that you will not bring any claim personally against Debitsuccess’
        employees in respect of any losses you suffer in connection with this
        website.
      </Styled.ContentBody>
      <Styled.ContentBody>
        Without prejudice to the foregoing paragraph, you agree that the
        limitations of warranties and liability set out in this website
        disclaimer will protect Debitsuccess’ employees, agents, subsidiaries,
        successors, assigns and sub-contractors as well as Debitsuccess.
      </Styled.ContentBody>
      <Styled.ContentSubHeading>
        Unenforceable provisions
      </Styled.ContentSubHeading>
      <Styled.ContentBody>
        If any provision of this website disclaimer is, or is found to be,
        unenforceable under applicable law, that will not affect the
        enforceability of the other provisions of this website disclaimer.
      </Styled.ContentBody>
      <Styled.ContentSubHeading>Indemnity</Styled.ContentSubHeading>
      <Styled.ContentBody>
        Without limiting any other provision of these terms and conditions, you
        agree to indemnify Debitsuccess and undertake to keep Debitsuccess
        indemnified against any losses, damages, costs, liabilities and expenses
        (including without limitation legal expenses and any amount paid by
        Debitsuccess to a third party in settlement of a claim or dispute on the
        advice of Debitsuccess’ legal advisors) incurred or suffered by
        Debitsuccess arising out of any breach by you of any provision of these
        terms and conditions.
      </Styled.ContentBody>
      <Styled.ContentSubHeading>
        Breaches of these terms and conditions
      </Styled.ContentSubHeading>
      <Styled.ContentBody>
        Without prejudice to Debitsuccess’ other rights under these terms and
        conditions, if you breach these terms and conditions in any way,
        Debitsuccess may take such action as Debitsuccess deems appropriate to
        deal with the breach, including suspending your access to the website,
        prohibiting you from accessing the website, blocking computers using
        your IP address from accessing the website, contacting your internet
        service provider to request that they block your access to the website
        and/or bringing court proceedings against you.
      </Styled.ContentBody>
      <Styled.ContentSubHeading>Variation</Styled.ContentSubHeading>
      <Styled.ContentBody>
        Debitsuccess may revise these terms and conditions from time to time.
        Revised terms and conditions will apply to the use of this website from
        the date of the publication of the revised terms and conditions on this
        website. Please check this page regularly to ensure you are familiar
        with the current version.
      </Styled.ContentBody>
      <Styled.ContentSubHeading>Severability</Styled.ContentSubHeading>
      <Styled.ContentBody>
        If a provision of these terms and conditions is determined by any court
        or other competent authority to be unlawful and/or unenforceable, the
        other provisions will continue in effect. If any unlawful and/or
        unenforceable provision would be lawful or enforceable if part of it
        were deleted, that part will be deemed to be deleted, and the rest of
        the provision will continue in effect.
      </Styled.ContentBody>
      <Styled.ContentSubHeading>Entire agreement</Styled.ContentSubHeading>
      <Styled.ContentBody>
        These terms and conditions constitute the agreement between you and
        Debitsuccess in relation to your use of this website, and supersede all
        previous agreements in respect of your use of this website.
      </Styled.ContentBody>
    </div>
  );
};

TcContent.propTypes = {};

export default TcContent;
